import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var PinIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M16.472 1h-8.88l-.18.012c-.798.141-1.32.76-1.32 1.488 0 .193.037.384.11.563l.097.239c.354.85.647 1.415.924 1.748l.167.191-.7 5.254-.134.114c-1.16 1.024-1.99 2.659-2.5 4.485A1.5 1.5 0 005.5 16.997H11v4.953a.5.5 0 00.13.335l.493.545a.5.5 0 00.743-.002l.507-.565A.5.5 0 0013 21.93v-4.933h5.563l.18-.012c.798-.14 1.32-.76 1.32-1.488a1.5 1.5 0 00-.055-.404l-.106-.36c-.516-1.656-1.313-3.17-2.395-4.125l-.134-.114-.701-5.252.168-.192c.177-.212.36-.518.56-.932l.177-.38.187-.436.098-.239A1.5 1.5 0 0016.472 1zM8.346 2.995L15.715 3l-.132.282-.058.116-.103.192a1.35 1.35 0 01-.119.18c-.108.131-.224.25-.348.359l-.402.353.947 7.1.344.252.201.156c.79.647 1.404 1.772 1.839 3.01L6.18 14.997c.47-1.337 1.151-2.512 2.039-3.162l.344-.252.947-7.102-.402-.353a3.202 3.202 0 01-.348-.358.99.99 0 01-.074-.106l-.094-.163a5.379 5.379 0 01-.053-.103l-.12-.245-.073-.158z",
                        fillRule: "evenodd",
                        clipRule: "evenodd"
                    })
                })
            })
        ]
    });
};
PinIcon.isCarinaIcon = true;
export default PinIcon;
